export default __webpack_public_path__ + "static/csv/HomeTiles.a90af3b2.csv";